import { render, staticRenderFns } from "./TwoFactorAuthenticationSettings.vue?vue&type=template&id=5c914c3e&scoped=true&"
import script from "./TwoFactorAuthenticationSettings.vue?vue&type=script&lang=js&"
export * from "./TwoFactorAuthenticationSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c914c3e",
  null
  
)

export default component.exports